import { moment } from '@eventbrite/date';
import { gettext } from '@eventbrite/i18n';
import { TonedenSubscription } from '@eventbrite/marketing-hub-ui';
import get from 'lodash/get';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import '../ActivationStrip/BoostActivationStrip.scss';
import { trackEvent } from '../analytics/analytics';
import {
    CLICK_STRIP_TRIAL_SUBSCRIPTION_ACTION,
    ON_TRIAL_SUBSCRIPTION_BANNER_FEATURE,
    POST_TRIAL_SUBSCRIPTION_BANNER_FEATURE,
    STRIP_TRIAL_SUBSCRIPTION,
} from '../constants';
import { TrialDescription, TrialTittle } from './MarketingHubFooterTrial';

export const BoostActivationStripTittle = gettext(
    'Your free trial is over',
).toString();

export const BoostActivationStripDescription = gettext(
    'Subscribe now to increase your ticket sales and keep your audience engaged.',
).toString();

export const hasTonedenSubscription = (tonedenSubscription: any) => {
    if (!tonedenSubscription) return false;
    const subscription = get(tonedenSubscription, 'subscription');
    if (!subscription) return false;
    return true;
};

export const isTrialAccount = (plan_id?: string) => {
    return plan_id === 'trialing' || plan_id === 'ads-trial';
};

const trialHasPassed = (trialEndTimestamp: number) => {
    const current = moment().startOf('day');
    const trialEnd = moment.unix(trialEndTimestamp);

    return (
        moment.duration(current.diff(trialEnd)).asDays() >= 0 &&
        moment.duration(current.diff(trialEnd)).asDays() <= 30
    );
};

const shouldShowOnTrial = (
    showPostTrial: boolean,
    trialEndTimestamp: number,
) => {
    return !showPostTrial && trialEndTimestamp > moment().unix();
};

export const tonedenSubscriptionInformation = (
    showPostTrial: boolean,
    subscription?: TonedenSubscription,
    customDescription?: string,
) => {
    let title;
    let description;
    let isTrialing = false;

    const trialEndTimestamp = subscription?.ads_trial_end_timestamp || 0;

    if (shouldShowOnTrial(showPostTrial, trialEndTimestamp)) {
        const trialEndDays = moment.unix(trialEndTimestamp).fromNow(true);
        title = TrialTittle(trialEndDays);
        description = TrialDescription;
        isTrialing = true;
    } else if (trialHasPassed(trialEndTimestamp)) {
        title = BoostActivationStripTittle;
        description = customDescription
            ? customDescription
            : BoostActivationStripDescription;
    }

    return { title, description, isTrialing };
};

const onSubscriptionClick = (
    history: RouteComponentProps['history'],
    isTrialing: boolean,
    sourceText: string,
) => {
    trackEvent({
        category: STRIP_TRIAL_SUBSCRIPTION,
        action: CLICK_STRIP_TRIAL_SUBSCRIPTION_ACTION,
        source: sourceText,
        feature: isTrialing
            ? ON_TRIAL_SUBSCRIPTION_BANNER_FEATURE
            : POST_TRIAL_SUBSCRIPTION_BANNER_FEATURE,
    });
    history.push('/settings/billing/subscribe?returnUrl=true');
};

export interface ButtonsProps {
    history: RouteComponentProps['history'];
    customButtonText?: string;
    isTrialing: boolean;
    source: string;
}

export const BoostActivationStripButtons = (props: ButtonsProps) => {
    const buttonText = props.customButtonText
        ? props.customButtonText
        : gettext('Subscribe now');
    return (
        <div>
            <div>
                <button
                    className="boost-activation-strip__btn"
                    onClick={() =>
                        onSubscriptionClick(
                            props.history,
                            props.isTrialing,
                            props.source,
                        )
                    }
                >
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export const BoostActivationStripIcon = (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#3659E3" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9998 5.53845L7.38477 13.9423H12.0002V18.4615L16.6155 10.0654L11.9998 10.0615V5.53845Z"
            fill="#EFF2FD"
        />
    </svg>
);
